module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvcGxhY2Vob2xkZXIuMTU4OTBmMDgucG5nIjs="